app.service('tor2Service', [
  function () {
    const service = this;

    const TYPE_OF_CELL = {
      COLUMN_HEADER: 'columnheader',
      COLUMN_SUB_HEADER: 'columnsubheader',
      ROW_HEADER: 'rowheader',
      LABEL: 'label',
      TEXT_BOX: 'textboxquestion',
      CHECK_BOX: 'checkboxquestion',
      DROP_DOWN: 'dropdownquestion',
      SEPARATOR: 'separator'
    };
    service.TYPE_OF_CELL = TYPE_OF_CELL;

    const MANDATORY_ENUM = {
      NONE: 'none',
      AT_LEAST_ONE: 'at_least_one',
      ALL: 'all'
    };
    service.MANDATORY_ENUM = MANDATORY_ENUM;

    const HEADER_WIDTH_UI_TYPE_ENUM = {
      PERCENT: '%',
      PIXEL: 'px'
    };

    const HEADER_WIDTH_API_TYPE_ENUM = {
      PERCENT: 'percent',
      PIXEL: 'pixels'
    };

    service.HEADER_WIDTH_UI_TYPE_ENUM = HEADER_WIDTH_UI_TYPE_ENUM;

    const CELL_PROPS = {
      ROW: 'row',
      COL: 'col',
      TYPE: 'type',
      CONTENT_MARKDOWN: 'content_markdown',
      DISABLE_ROW_REMAINDER_IF_UNCHECKED: 'disable_row_remainder_if_unchecked',
      OPTIONS: 'options',
      MANDATORY: 'mandatory',
      MULTI_SELECT: 'multi_select',
      SPAN_WHOLE_ROW: 'span_whole_row',
      SINGLE_LINE: 'single_line',
      SELECTED: 'selected',
      NUMERIC: 'numeric',
      MAX_LENGTH: 'max_length',
      MIN_LENGTH: 'min_length',
      PLACEHOLDER: 'placeholder',
      WIDTH: 'width',
      WIDTH_PROPS: {
        AMOUNT: 'amount',
        UNIT: 'unit'
      },
      HIDE_COLUMN: 'hide_column'
    };
    service.CELL_PROPS = CELL_PROPS;

    const COPY_OPTIONS_ENUM = {
      TEXT_AND_OPTIONS: 'text_and_options',
      TEXT_ONLY: 'text_only',
      OPTIONS_ONLY: 'options_only'
    };
    service.COPY_OPTIONS_ENUM = COPY_OPTIONS_ENUM;

    const CONFIG_KEY = 'config';
    service.CONFIG_KEY = 'config';

    const CONFIG_PROPS = {
      HIDE_FIRST_COL: 'hide_first_col'
    };
    service.CONFIG_PROPS = CONFIG_PROPS;

    /** *
     * Converts Header Width UI Enum to API Enum
     * @param uiEnum {HEADER_WIDTH_UI_TYPE_ENUM} The Header Width UI Enum
     * @return {HEADER_WIDTH_API_TYPE_ENUM} The Header Width API Enum
     */
    const convertHeaderWidthEnumForAPI = function (uiEnum) {
      return uiEnum === HEADER_WIDTH_UI_TYPE_ENUM.PERCENT
        ? HEADER_WIDTH_API_TYPE_ENUM.PERCENT
        : HEADER_WIDTH_API_TYPE_ENUM.PIXEL;
    };

    /** *
     * Converts Header Width API Enum to UI Enum
     * @param apiEnum {HEADER_WIDTH_API_TYPE_ENUM} The Header Width API Enum
     * @return {HEADER_WIDTH_UI_TYPE_ENUM} The Header Width UI Enum
     */
    const convertHeaderWidthEnumForUI = function (apiEnum) {
      return apiEnum === HEADER_WIDTH_API_TYPE_ENUM.PERCENT
        ? HEADER_WIDTH_UI_TYPE_ENUM.PERCENT
        : HEADER_WIDTH_UI_TYPE_ENUM.PIXEL;
    };

    /** *
     * If value is undefined or null, returns the `defaultValue` specified.1
     * @param value {null|*} Any value
     * @param defaultValue {null|*} A default value to return
     * @return {*}
     */
    const defaultIfUndefined = function (value, defaultValue) {
      return value ? value : defaultValue;
    };

    /** *
     * Fetches default mandator value for a particular cell type
     * @param typeOfCell {string} The type of cell
     * @return {null|string|boolean}
     */
    const fetchDefaultMandatoryValueFor = function (typeOfCell) {
      const booleanValues = [
        TYPE_OF_CELL.TEXT_BOX, TYPE_OF_CELL.DROP_DOWN
      ];

      if (booleanValues.indexOf(typeOfCell) > -1) {
        return false;
      }

      if (typeOfCell === TYPE_OF_CELL.ROW_HEADER) {
        return MANDATORY_ENUM.NONE;
      }

      return null;
    };

    /** *
     * Creates a structure of the default cell.
     * @param typeOfCell {TYPE_OF_CELL} The type of the cell to create
     * @param contentMarkdown {string|null} The content of the cell.
     * @param row {number} The row number of the cell (0 indexed)
     * @param col {number} The col number of the cell (0 indexed)
     * @return {{}}
     */
    const createDefaultCell = function (typeOfCell, contentMarkdown, row, col) {
      const cell = {};
      cell[CELL_PROPS.ROW] = row == null ? 0 : row;
      cell[CELL_PROPS.COL] = col == null ? 0 : col;
      cell[CELL_PROPS.TYPE] = typeOfCell;
      cell[CELL_PROPS.CONTENT_MARKDOWN] = contentMarkdown == null ? '' : contentMarkdown;
      cell[CELL_PROPS.DISABLE_ROW_REMAINDER_IF_UNCHECKED] = false;
      cell[CELL_PROPS.OPTIONS] = null;
      cell[CELL_PROPS.MANDATORY] = fetchDefaultMandatoryValueFor(typeOfCell);
      cell[CELL_PROPS.MULTI_SELECT] = false;
      cell[CELL_PROPS.SPAN_WHOLE_ROW] = false;

      return cell;
    };

    /** *
     * Creates a ROW HEADER cell.
     * @param cellContent {string} The content of the cell
     * @param mandatory {MANDATORY_ENUM} The mandatory flag for this row.
     * @param rowNumber {number} The row number for this cell.
     * @return {{}}
     */
    const createNewRowHeaderCell = function (cellContent, mandatory, rowNumber) {
      const cell = createDefaultCell(TYPE_OF_CELL.ROW_HEADER, cellContent, rowNumber, 0);
      cell[CELL_PROPS.MANDATORY] = mandatory == null ? MANDATORY_ENUM.NONE : mandatory;
      cell[CELL_PROPS.WIDTH] = null;
      return cell;
    };

    /** *
     * Creates a new Label Cell.
     * @param cellContent {string} The content of the cell
     * @param rowNumber {number} The row number (0 indexed)
     * @param colNumber {number} The column number (0 indexed)
     * @return {{}}
     */
    service.create_new_label_cell = function (cellContent, rowNumber, colNumber) {
      return  createDefaultCell(TYPE_OF_CELL.LABEL, cellContent, rowNumber, colNumber);
    };

    /** *
     * Creates a HEADER cell (or Sub-Header).
     * @param column {number} The column number
     * @param isSubHeader {boolean} Whether this is a sub-header cell
     * @return {{col: *, row: number, type: string, content_markdown: string}}
     */
    service.create_header_cell = function (column, isSubHeader) {
      const cell = {
        type: isSubHeader ? TYPE_OF_CELL.COLUMN_SUB_HEADER : TYPE_OF_CELL.COLUMN_HEADER,
        content_markdown: (isSubHeader ? 'Sub ' : '') + 'Header Cell',
        col: column,
        row: 0,
        hide_column: false
      };

      if (isSubHeader) {
        cell.is_sub_header_cell = true;
      } else {
        cell.is_header_cell = true;
        cell.width = null;
      }

      return cell;
    };

    /** *
     * Creates a row for the Column Header (or Sub Header)
     * @param isSubHeaderRow {boolean} Whether this is for the sub-header row
     * @param existingRow {Array<Object>} The existing row in question from the UI
     * @param colCount {number} The number of columns
     * @return {[]}
     */
    service.create_column_header_row = function (isSubHeaderRow, existingRow, colCount) {
      const row = [];
      for (let i=0; i<colCount; i++) {
        if (existingRow != null && existingRow[i] != null) {
          row.push(existingRow[i]);
        } else {
          row.push(service.create_header_cell(i, isSubHeaderRow));
        }
      }

      return row;
    };

    /** *
     * Creates a default row with the first cell being a ROW HEADER and rest of the cells being
     * LABEL cells.
     * @param rowNumber {number} The row number for this row.
     * @param colCount {number} The number of columns
     * @return {[]}
     */
    service.create_new_default_row = function (rowNumber, colCount) {
      const row = [];

      for (let i=0; i<colCount; i++) {
        if (i === 0) {
          row.push(createNewRowHeaderCell('Row', MANDATORY_ENUM.ALL, rowNumber));
        } else {
          row.push(service.create_new_label_cell('Label Cell', rowNumber, i));
        }
      }

      return row;
    };

    /** *
     * Runs through all the TOR2 data and validates it
     * @param data
     * @return {string|null}
     */
    service.validate_tor_data = function (data, randomize_options) {
      const result = [];

      if (data == null || data.length === 0 || data[0].length === 0) {
        result.push('No TOR data specified.');
        return result;
      }

      // This errCount is required to differentiate error messages incase 2 errors have the same row and col headers
      let errCount = 1;

      // Check if there any dropdowns without options -- or dropdowns with just 1 option
      let i, j, row, cell, message;
      for (i=0; i<data.length; i++) {
        row = data[i];

        // Make sure there is no separator row in question which need to be randomized
        if (randomize_options && row[0].type == TYPE_OF_CELL.SEPARATOR) {
          result.push(errCount + '. Separator Rows are not allowed with randomize options');
          errCount++;
        }

        for (j=0; j<row.length; j++) {
          cell = row[j];

          if (cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.DROP_DOWN &&
            (cell[CELL_PROPS.OPTIONS] == null ||
            cell[CELL_PROPS.OPTIONS].length < 2)) {

            message = errCount + '. A dropdown cell has fewer than 2 options. Please add at least 2 options in dropdowns to continue.';
            if (data[0][j][CELL_PROPS.TYPE] === TYPE_OF_CELL.COLUMN_HEADER) {
              const colHeaderText = data[0][j][CELL_PROPS.CONTENT_MARKDOWN];
              const rowHeaderText = row[0][CELL_PROPS.CONTENT_MARKDOWN];

              message = errCount + '. The dropdown at Row: "' + rowHeaderText + '" and Column: "' + colHeaderText +
              '" has fewer than 2 options. Please add at least 2 options to continue.';
            }

            errCount++;
            result.push(message);
          }
        }
      }

      const cellTypesToIgnore = [
        TYPE_OF_CELL.SEPARATOR,
        TYPE_OF_CELL.COLUMN_SUB_HEADER,
        TYPE_OF_CELL.COLUMN_HEADER
      ];

      // Going through all the rows and making sure there are input elements specified if the row is expecting one/all inputs to be filled
      for (i=1; i<data.length; i++) {
        row = data[i];
        const firstCell = row[0];

        // Skip the check if this row is a separator row
        if (cellTypesToIgnore.indexOf(firstCell[CELL_PROPS.TYPE]) > -1) {
          continue;
        }

        if (firstCell[CELL_PROPS.MANDATORY] !== MANDATORY_ENUM.NONE) {
          // Go through the other cells and make sure there is atleast one input element (textbox or dropdown)
          let inputsPresent = false;
          for (j=1; j<row.length; j++) {
            cell = row[j];
            if (cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.TEXT_BOX || cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.DROP_DOWN) {
              inputsPresent = true;
              break;
            }
          }

          if (!inputsPresent) {
            message = errCount + '. No input elements (text or dropdown) were found on Row ' + i + '. Please add input elements or allow payer to leave the row empty.';
            result.push(message);
            errCount++;
          }
        }
      }

      return result;
    };

    /** *
     * Processes the separator cell values for sending to the API
     * @param cell {Object} Data values from the UI
     * @return {{}}
     */
    const processSeparatorCellForApi = function (cell) {
      const result = {};
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.SEPARATOR;
      result[CELL_PROPS.CONTENT_MARKDOWN] = defaultIfUndefined(cell[CELL_PROPS.CONTENT_MARKDOWN], '');
      result[CELL_PROPS.SPAN_WHOLE_ROW] = defaultIfUndefined(cell[CELL_PROPS.SPAN_WHOLE_ROW], false);

      return result;
    };

    /** *
     * Creates an API friendly Separator Row based on the various properties of the separator
     * @param row
     */
    const processSeparatorRowForApi = function (row) {
      const separatorRow = [];

      if (row[0][CELL_PROPS.SPAN_WHOLE_ROW] === true) {
        // Duplicate the first cell info across all the cells
        const firstCell = processSeparatorCellForApi(row[0]);

        for (let i=0; i<row.length; i++) {
          separatorRow.push(angular.copy(firstCell));
        }
      } else {
        // This is not a spanning separator - so construct each cell as per UI
        for (let i=0; i<row.length; i++) {
          const processedCell = processSeparatorCellForApi(row[i]);
          separatorRow.push(processedCell);
        }
      }

      return separatorRow;
    };

    /** *
     * Converts the data returned by the API for Column Headers and converts it to the UI format.
     * If no columnheader is returned from the API, a `null` value is returned.
     * @param data {Array<Array<Object>>} The TOR2 data from the Backend
     * @param hideFirstCol {boolean} Whether the first column in TOR is to be hidden
     * @return {null|*[]}
     */
    service.fetch_ui_column_header_data = function (data, hideFirstCol) {
      if (data == null || data.length === 0 || data[0] == null || data[0].length === 0) {
        return null;
      }

      if (data[0][0][CELL_PROPS.TYPE] === TYPE_OF_CELL.COLUMN_HEADER) {
        const numOfColumns = data[0].length;
        const row = service.create_column_header_row(false, null, numOfColumns);

        // If first column is to be hidden, add prop to the first column's header cell
        if (hideFirstCol) {
          row[0][CELL_PROPS.HIDE_COLUMN] = hideFirstCol;
        }

        for (let i=0; i<numOfColumns; i++) {
          if (data[0][i][CELL_PROPS.CONTENT_MARKDOWN] != null) {
            row[i][CELL_PROPS.CONTENT_MARKDOWN] = data[0][i][CELL_PROPS.CONTENT_MARKDOWN];
          }

          if (data[0][i][CELL_PROPS.WIDTH] != null) {
            const widthProp = {};
            widthProp[CELL_PROPS.WIDTH_PROPS.UNIT] = convertHeaderWidthEnumForUI(data[0][i][CELL_PROPS.WIDTH][CELL_PROPS.WIDTH_PROPS.UNIT]);
            widthProp[CELL_PROPS.WIDTH_PROPS.AMOUNT] = parseInt(data[0][i][CELL_PROPS.WIDTH][CELL_PROPS.WIDTH_PROPS.AMOUNT]);

            row[i][CELL_PROPS.WIDTH] = widthProp;
          }
        }

        return row;
      }

      return null;
    };

    /** *
     * Converts the data returned by the API for Column Sub Headers and converts it to the UI format.
     * If no columnsubheader is returned from the API, a `null` value is returned.
     * @param data {Array<Array<Object>>} The TOR2 data from the Backend
     * @return {null|*[]}
     */
    service.fetch_ui_column_sub_header_data = function (data) {
      // Checking if the data has atleast 2 rows
      if (data == null || data.length < 2 || data[1] == null || data[1].length === 0) {
        return null;
      }

      // Checking if the first row is COLUMN_SUB_HEADER (very unlikely).
      if (data[1][0][CELL_PROPS.TYPE] === TYPE_OF_CELL.COLUMN_SUB_HEADER) {
        const numOfColumns = data[1].length;
        const row = service.create_column_header_row(true, null, numOfColumns);

        for (let i=0; i<numOfColumns; i++) {
          if (data[1][i][CELL_PROPS.CONTENT_MARKDOWN] != null) {
            row[i][CELL_PROPS.CONTENT_MARKDOWN] = data[1][i][CELL_PROPS.CONTENT_MARKDOWN];
          }
        }

        return row;
      }

      return null;
    };

    /** *
     * Creates the data structure required to render a Label Cell
     * @param baseData {Object} Starting value on which to build on.
     * @param cell {Object} Cell data from the API
     * @return {{}}
     */
    const processLabelCell = function (baseData, cell) {
      const result = angular.copy(baseData);
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.LABEL;
      result[CELL_PROPS.CONTENT_MARKDOWN] = cell[CELL_PROPS.CONTENT_MARKDOWN];
      return result;
    };

    /** *
     * Constructs a clean textbox cell expected by the API from data received from the UI
     * @param baseData {Object} Starting value on which to build on.
     * @param cell {Object} The UI cell values
     * @return {{}}
     */
    const processTextBoxCell = function (baseData, cell) {
      const result = angular.copy(baseData);
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.TEXT_BOX;
      result[CELL_PROPS.MANDATORY] = defaultIfUndefined(cell[CELL_PROPS.MANDATORY], false);
      result[CELL_PROPS.PLACEHOLDER] = defaultIfUndefined(cell[CELL_PROPS.PLACEHOLDER], '');
      result[CELL_PROPS.SINGLE_LINE] = defaultIfUndefined(cell[CELL_PROPS.SINGLE_LINE], false);
      result[CELL_PROPS.NUMERIC] = defaultIfUndefined(cell[CELL_PROPS.NUMERIC], false);
      result[CELL_PROPS.MAX_LENGTH] = defaultIfUndefined(cell[CELL_PROPS.MAX_LENGTH], null);
      result[CELL_PROPS.MIN_LENGTH] = defaultIfUndefined(cell[CELL_PROPS.MIN_LENGTH], null);

      return result;
    };

    /** *
     * Creates the data structure required to render a Row Header Cell
     * @param baseData {Object} Starting value on which to build on.
     * @param cell {Object} Cell data from the API
     * @return {{}}
     */
    const processRowHeaderCell = function (baseData, cell) {
      const result = angular.copy(baseData);
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.ROW_HEADER;
      result[CELL_PROPS.CONTENT_MARKDOWN] = defaultIfUndefined(cell[CELL_PROPS.CONTENT_MARKDOWN], '');
      result[CELL_PROPS.MANDATORY] = defaultIfUndefined(cell[CELL_PROPS.MANDATORY], MANDATORY_ENUM.ALL);

      return result;
    };

    /** *
     * Creates the data structure required to render a Separator Cell
     * @param baseData {Object} Starting value on which to build on.
     * @param cell {Object} Cell data from the API
     * @return {{}}
     */
    const processSeparatorCellForUI = function (baseData, cell) {
      const result = angular.copy(baseData);
      result[CELL_PROPS.CONTENT_MARKDOWN] = defaultIfUndefined(cell[CELL_PROPS.CONTENT_MARKDOWN], '');
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.SEPARATOR;
      result[CELL_PROPS.SPAN_WHOLE_ROW] = defaultIfUndefined(cell[CELL_PROPS.SPAN_WHOLE_ROW], false);

      return result;
    };

    /** *
     * Creates the data structure required to render a Dropdown Cell
     * @param baseData {Object} Starting value on which to build on.
     * @param cell {Object} Cell data from the API
     * @return {{}}
     */
    const processDropdownCell = function (baseData, cell) {
      const result = angular.copy(baseData);
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.DROP_DOWN;
      result[CELL_PROPS.MANDATORY] = defaultIfUndefined(cell[CELL_PROPS.MANDATORY], false);
      result[CELL_PROPS.MULTI_SELECT] = defaultIfUndefined(cell[CELL_PROPS.MULTI_SELECT], false);
      result[CELL_PROPS.OPTIONS] = angular.copy(defaultIfUndefined(cell[CELL_PROPS.OPTIONS], []));

      return result;
    };

    /** *
     * Creates the data structure required to render a Checkbox Cell
     * @param baseData {Object} Starting value on which to build on.
     * @param cell {Object} Cell data from the API
     * @return {{}}
     */
    const processCheckboxCell = function (baseData, cell) {
      const result = angular.copy(baseData);
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.CHECK_BOX;
      result[CELL_PROPS.DISABLE_ROW_REMAINDER_IF_UNCHECKED]= defaultIfUndefined(cell[CELL_PROPS.DISABLE_ROW_REMAINDER_IF_UNCHECKED], false);

      return result;
    };

    /** *
     * Creates the data structure required to render a UI Cell from API data
     * @param cell {Object} Cell data from the API
     * @param row {Number} The row number
     * @param col {Number} The column number
     * @return {{}}
     */
    const processForUI = function (cell, row, col) {
      switch (cell[CELL_PROPS.TYPE]) {
        case TYPE_OF_CELL.LABEL:
          return processLabelCell(
            createDefaultCell(TYPE_OF_CELL.LABEL, null, row, col),
            cell);

        case TYPE_OF_CELL.TEXT_BOX:
          return processTextBoxCell(
            createDefaultCell(TYPE_OF_CELL.TEXT_BOX, null, row, col),
            cell);

        case TYPE_OF_CELL.ROW_HEADER:
          return processRowHeaderCell(
            createDefaultCell(TYPE_OF_CELL.ROW_HEADER, cell[CELL_PROPS.CONTENT_MARKDOWN], row, col),
            cell);

        case TYPE_OF_CELL.SEPARATOR:
          return processSeparatorCellForUI(
            createDefaultCell(TYPE_OF_CELL.SEPARATOR, null, row, col),
            cell);

        case TYPE_OF_CELL.DROP_DOWN:
          return processDropdownCell(
            createDefaultCell(TYPE_OF_CELL.DROP_DOWN, null, row, col),
            cell);

        case TYPE_OF_CELL.CHECK_BOX:
          return processCheckboxCell(
            createDefaultCell(TYPE_OF_CELL.CHECK_BOX, null, row, col),
            cell);
      }
    };

    /** *
     * Constructs a clean TOR BODY cell expected by the API from data received from the UI
     * @param cell {Object} The UI cell values
     * @return {{}}
     */
    const processTorBodyCellForApi = function (cell) {
      switch (cell[CELL_PROPS.TYPE]) {
        case TYPE_OF_CELL.ROW_HEADER:
          return processRowHeaderCell({}, cell);

        case TYPE_OF_CELL.LABEL:
          return processLabelCell({}, cell);

        case TYPE_OF_CELL.CHECK_BOX:
          return processCheckboxCell({}, cell);

        case TYPE_OF_CELL.TEXT_BOX:
          return processTextBoxCell({}, cell);

        case TYPE_OF_CELL.DROP_DOWN:
          return processDropdownCell({}, cell);
      }
    };

    /** *
     * Constructs the TOR BODY for the UI from the API data
     * @param data {Array<Array<Object>>}
     * @return {null|[]}
     */
    service.fetch_ui_tor_body_data = function (data) {
      if (data == null || data.length === 0 || data[0] == null || data[0].length === 0) {
        return null;
      }

      const cellTypesToSkip = [ TYPE_OF_CELL.COLUMN_HEADER, TYPE_OF_CELL.COLUMN_SUB_HEADER ];
      const torBody = [];
      let rowNum = 0;

      // Run through all the rows in the data
      for (let i=0; i<data.length; i++) {
        // Ensure basic cleanliness
        if (data[i].length > 0 && data[i] != null) {
          // Skip if these are header type cells
          if (cellTypesToSkip.indexOf(data[i][0][CELL_PROPS.TYPE]) > -1) {
            continue;
          }
        }

        const row = [];
        // Non header rows. Go through all cells and convert them to UI expected formats
        for (let j=0; j<data[i].length; j++) {
          row.push(processForUI(data[i][j], rowNum, j));
        }

        torBody.push(row);
        rowNum++;
      }

      return torBody;
    };

    /** *
     * Constructs a clean columnheader cell expected by the API from data received from the UI
     * @param cell {Object} The UI cell values
     * @return {{}}
     */
    const processHeaderCellForApi = function (cell) {
      const result = {};
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.COLUMN_HEADER;
      result[CELL_PROPS.CONTENT_MARKDOWN] = defaultIfUndefined(cell[CELL_PROPS.CONTENT_MARKDOWN], '');

      if (cell[CELL_PROPS.WIDTH] == null) {
        result[CELL_PROPS.WIDTH] = null;
      } else {
        const widthProp = {};
        widthProp[CELL_PROPS.WIDTH_PROPS.AMOUNT] = parseInt(cell[CELL_PROPS.WIDTH][CELL_PROPS.WIDTH_PROPS.AMOUNT]);
        widthProp[CELL_PROPS.WIDTH_PROPS.UNIT] = convertHeaderWidthEnumForAPI(cell[CELL_PROPS.WIDTH][CELL_PROPS.WIDTH_PROPS.UNIT]);
        result[CELL_PROPS.WIDTH] = widthProp;
      }

      return result;
    };

    /** *
     * Constructs a clean columnsubheader cell expected by the API from data received from the UI
     * @param cell {Object} The UI cell values
     * @return {{}}
     */
    const processSubHeaderCellForApi = function (cell) {
      const result = {};
      result[CELL_PROPS.TYPE] = TYPE_OF_CELL.COLUMN_SUB_HEADER;
      result[CELL_PROPS.CONTENT_MARKDOWN] = defaultIfUndefined(cell[CELL_PROPS.CONTENT_MARKDOWN], '');

      return result;
    };

    /** *
     * Creates TOR2 data structure expected by the API by taking in the UI data formats
     * @param headerData {Array<Object>|null} Array of Header Cells
     * @param subHeaderData {Array<Object>|null} Array of Sub Header Cells
     * @param bodyData {Array<Array<Object>>} Array of Array of TOR Body Cells
     * @return Object
     */
    service.create_data_for_api = function (headerData, subHeaderData, bodyData) {
      const result = [];

      if (headerData != null) {
        const headerRow = [];
        for (let i = 0; i < headerData.length; i++) {
          headerRow.push(processHeaderCellForApi(headerData[i]));
        }

        result.push(headerRow);
      }

      if (subHeaderData != null) {
        const subHeaderRow = [];
        for (let i = 0; i < subHeaderData.length; i++) {
          subHeaderRow.push(processSubHeaderCellForApi(subHeaderData[i]));
        }
        result.push(subHeaderRow);
      }

      for (let r = 0; r < bodyData.length; r++) {
        const row = bodyData[r];

        // Checking if this is a separator row as that needs special processing
        if (row[0][CELL_PROPS.TYPE] === TYPE_OF_CELL.SEPARATOR) {
          result.push(processSeparatorRowForApi(row));
        } else {
          const processedRow = [];
          for (let c = 0; c < row.length; c++) {
            processedRow.push(processTorBodyCellForApi(bodyData[r][c]));
          }
          result.push(processedRow);
        }
      }

      const tor2Data = {
        cells: result
      };

      if (headerData[0] && headerData[0][CELL_PROPS.HIDE_COLUMN] === true) {
        tor2Data[CONFIG_KEY] = {};
        tor2Data[CONFIG_KEY][CONFIG_PROPS.HIDE_FIRST_COL] = true;
      }

      return tor2Data;
    };

    /** *
     * Construct a CSS style for the specified cell
     * @param cell
     */
    service.get_cell_style = function (cell) {
      // If the first column is hidden, then reset the column to 30px in width
      if (cell[CELL_PROPS.HIDE_COLUMN] === true) {
        return 'width: 30px';
      }

      if (cell[CELL_PROPS.WIDTH] != null) {
        return 'width: ' + cell[CELL_PROPS.WIDTH][CELL_PROPS.WIDTH_PROPS.AMOUNT] +
          cell[CELL_PROPS.WIDTH][CELL_PROPS.WIDTH_PROPS.UNIT];
      }

      return '';
    };

    /** *
     * Calculates the column span required for the specific row.
     * @param row {number} The row whose col span is to be calculated.
     * @return {number}
     */
    service.fetch_col_span = function (row) {
      if (row[0][CELL_PROPS.TYPE] !== TYPE_OF_CELL.SEPARATOR) {
        return 1;
      }

      return row[0][CELL_PROPS.SPAN_WHOLE_ROW] === true ? row.length : 1;
    };

    /** *
     * Returns the cells in a specific row to render on the UI.
     * Checks whether it is a normal row or a separator row with width spanning all columns.
     * @param row {number} The row number to calculate for.
     * @return {[]}
     */
    service.fetch_cells_from_row = function (row) {
      if (row[0][CELL_PROPS.TYPE] !== TYPE_OF_CELL.SEPARATOR) {
        return row;
      }

      // Just check the first row as that has the ability to set as merge cell
      return row[0][CELL_PROPS.SPAN_WHOLE_ROW] === true ? [row[0]] : row;
    };

    /** *
     * Returns whether this type of cell uses the content_markdown property.
     * @param typeOfCell {TYPE_OF_CELL} The type of the cell.
     * @return {boolean}
     */
    service.is_label_type_cell = function (typeOfCell) {
      return [
        TYPE_OF_CELL.LABEL, TYPE_OF_CELL.ROW_HEADER,
        TYPE_OF_CELL.COLUMN_HEADER,
        TYPE_OF_CELL.COLUMN_SUB_HEADER
      ].indexOf(typeOfCell) > -1;
    };

    /** *
     * Returns whether this is a single line textbox type of cell.
     * @param cell {Object} The actual cell.
     * @return {boolean}
     */
    service.is_single_line_textbox = function (cell) {
      if (cell == null) {
        return false;
      }

      return cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.TEXT_BOX &&
        cell[CELL_PROPS.SINGLE_LINE] === true;
    };

    /** *
     * Returns whether this is a multi line textbox type of cell.
     * @param cell {Object} The actual cell.
     * @return {boolean}
     */
    service.is_multi_line_textbox = function (cell) {
      if (cell == null) {
        return false;
      }

      return cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.TEXT_BOX &&
        cell[CELL_PROPS.SINGLE_LINE] !== true;
    };

    /** *
     * Returns whether this is a single selection dropdown cell.
     * @param cell {Object} The actual cell.
     * @return {boolean}
     */
    service.is_single_select_dropdown = function (cell) {
      if (cell == null) {
        return false;
      }

      return cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.DROP_DOWN &&
        cell[CELL_PROPS.MULTI_SELECT] !== true;
    };

    /** *
     * Returns whether this is a multi selection cell.
     * @param cell {Object} The actual cell.
     * @return {boolean}
     */
    service.is_multi_select_dropdown = function (cell) {
      if (cell == null) {
        return false;
      }

      return cell[CELL_PROPS.TYPE] === TYPE_OF_CELL.DROP_DOWN &&
        cell[CELL_PROPS.MULTI_SELECT] === true;
    };

    /** *
     * Returns whether this is a separator cell.
     * @param cellType {TYPE_OF_CELL} The type of the cell.
     * @return {boolean}
     */
    service.is_separator_cell = function (cellType) {
      return cellType === TYPE_OF_CELL.SEPARATOR;
    };
  }]);
